module.exports = __webpack_public_path__ + "media/customize/banner-push-top-eb7774b9.svg";